import { createContext, useContext } from "react";
import { LawTerm } from "@/models/law-term/LawTerm";

export type LawTermsContextType = {
  allLawTerms: LawTerm[] | null;
  isLoading: boolean;
  isError: boolean;
};

export const LawTermsContext = createContext<LawTermsContextType | undefined>(
  undefined
);

export const useLawTermsContext = () => {
  const context = useContext(LawTermsContext);
  if (!context) {
    throw new Error(
      "useLawTermsContext must be used within a LawTermsProvider"
    );
  }
  return context;
};
